module.exports = __webpack_public_path__ + "401d815dc206b8dc1b17cd0e37695975.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/marker-icon-2x.png
// module id = 1657
// module chunks = 185